import axios from '@/utils/axios'

// 投诉详情
export function GetComplainInfo (params) {
  return axios({
    url: '/SaleV2/SOrderComplain/GetComplainInfo',
    method: 'get',
    params: params
  })
}

// 投诉页面数据
export function GetSimpleProductInfo (params) {
  return axios({
    url: '/SaleV2/Product/GetSimpleProductInfo',
    method: 'get',
    params: params
  })
}

// 投诉提交
export function SubmitComplain (data) {
  return axios({
    url: '/SaleV2/SOrderComplain/SubmitComplain',
    method: 'post',
    data: data
  })
}
